import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToId, waOpen, DEFAULT_MSG } from "../lib/site";
import { WaIcon } from "./Logo";

const LINKS = [
    { id: "beneficios", label: "Benefícios", tid: "nav-link-benefits" },
    { id: "como-funciona", label: "Como funciona", tid: "nav-link-how-it-works" },
    { id: "categorias", label: "Categorias", tid: "nav-link-categories" },
    { id: "sindicos", label: "Para síndicos", tid: "nav-link-sindicos" },
    { id: "corporativo", label: "Para empresas", tid: "nav-link-corporativo" },
    { id: "novidades", label: "Novidades", tid: "nav-link-news" },
    { id: "faq", label: "FAQ", tid: "nav-link-faq" },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);

    const go = (id) => {
        setOpen(false);
        scrollToId(id);
    };

    return (
        <header className="fixed top-0 inset-x-0 z-50">
            <div className="mx-auto max-w-7xl px-4 sm:px-6">
                <div className="mt-3 rounded-2xl border-2 border-[#1A231E]/10 bg-[#073A22]/85 backdrop-blur-md px-4 sm:px-5 py-2.5 flex items-center justify-between shadow-[0_10px_30px_rgba(7,58,34,0.35)]">
                    <button
                        data-testid="nav-logo"
                        onClick={() => window.__lenis ? window.__lenis.scrollTo(0) : window.scrollTo({ top: 0, behavior: "smooth" })}
                        className="cursor-pointer"
                        aria-label="Conbox — início"
                    >
                        <Logo light />
                    </button>

                    <nav className="hidden lg:flex items-center gap-6">
                        {LINKS.map((l) => (
                            <button
                                key={l.id}
                                data-testid={l.tid}
                                onClick={() => go(l.id)}
                                className="text-sm font-semibold text-[#F7F4EC]/85 hover:text-[#F1C75B] transition-colors duration-200"
                            >
                                {l.label}
                            </button>
                        ))}
                    </nav>

                    <div className="flex items-center gap-2">
                        <button
                            data-testid="nav-cta-whatsapp"
                            onClick={() => go("solicitacao")}
                            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-[#F57A3A] hover:bg-[#E06324] text-[#F7F4EC] text-sm font-bold px-5 py-2.5 transition-all duration-200 hover:-translate-y-0.5"
                        >
                            <WaIcon className="w-4 h-4" />
                            Solicitar implantação
                        </button>
                        <button
                            data-testid="nav-mobile-toggle"
                            onClick={() => setOpen(!open)}
                            className="lg:hidden inline-flex items-center justify-center w-10 h-10 rounded-xl text-[#F7F4EC] hover:bg-[#F7F4EC]/10 transition-colors"
                            aria-label="Menu"
                        >
                            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
                        </button>
                    </div>
                </div>

                <AnimatePresence>
                    {open && (
                        <motion.nav
                            initial={{ opacity: 0, y: -12 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -12 }}
                            transition={{ duration: 0.25 }}
                            className="lg:hidden mt-2 rounded-2xl border-2 border-[#1A231E]/10 bg-[#073A22]/95 backdrop-blur-md p-4 flex flex-col gap-1"
                            data-testid="nav-mobile-menu"
                        >
                            {LINKS.map((l) => (
                                <button
                                    key={l.id}
                                    data-testid={l.tid}
                                    onClick={() => go(l.id)}
                                    className="text-left text-base font-semibold text-[#F7F4EC]/90 hover:text-[#F1C75B] px-3 py-2.5 rounded-xl hover:bg-[#F7F4EC]/5 transition-colors"
                                >
                                    {l.label}
                                </button>
                            ))}
                            <button
                                onClick={() => go("solicitacao")}
                                className="mt-2 inline-flex items-center justify-center gap-2 rounded-xl bg-[#F57A3A] text-[#F7F4EC] font-bold px-5 py-3"
                            >
                                <WaIcon className="w-4 h-4" />
                                Solicitar implantação
                            </button>
                        </motion.nav>
                    )}
                </AnimatePresence>
            </div>
        </header>
    );
}
